// api.js

import axiosInstance from '../axiosInstance'

export const marketDataService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post('/market-data', data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  fetch: async (limit, skip, clientId, searchValue) => {
    try {
      let response = await axiosInstance.get(
        `/market-data?$limit=${limit || 15}&$skip=${skip || 0}&${clientId ? `client_id=${clientId}&` : ''}&${
          searchValue ? `&name[$search]=${searchValue}` : ''
        }`
      )
      return response.data
    } catch (error) {
      throw error
    }
  },
  fetchById: async (id) => {
    try {
      let query = `/market-data/${id}`
      let response = await axiosInstance.get(query)
      return response.data
    } catch (error) {
      throw error
    }
  },
  edit: async (id, data) => {
    try {
      let response = await axiosInstance.patch(`/market-data/${id}`, data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  estimate: async (data) => {
    try {
      let response = await axiosInstance.post(`/market-data-estimation`, data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/market-data/${id}`)
      return response.data
    } catch (error) {
      throw error
    }
  }
}
